module.exports = __webpack_public_path__ + "static/media/main-stage-3-locked.2873fac0.png";